import * as React from 'react';
import { Badge } from 'wix-style-react';
import { translate } from 'react-i18next';
import { InvoiceStatus } from '@wix/ambassador-wix-quotes-web/types';
import { isStatusDisplayed } from './status-utils';
var skinMapping = {
    Draft: 'neutral',
    Processing: 'standard',
    Sent: 'neutralStandard',
    PartiallyPaid: 'warning',
    PartialAndOverdue: 'warning',
    Paid: 'success',
    Overdue: 'danger',
    Void: 'neutralDanger',
};
var statusToSkin = function (status) {
    return skinMapping[status] || 'warning';
};
var Status = function (_a) {
    var status = _a.status, isUoU = _a.isUoU, t = _a.t;
    if (!isStatusDisplayed({ status: status, isUoU: isUoU })) {
        return null;
    }
    var text = t("invoice-view:quote.preview_status." + status.toLowerCase());
    var skin = statusToSkin(status);
    return status === InvoiceStatus.PartialAndOverdue ? (React.createElement(PartialAndOverdue, { t: t })) : (React.createElement("div", { "data-hook": "status" },
        React.createElement(Badge, { dataHook: "status-badge", skin: skin }, text)));
};
var PartialAndOverdue = function (_a) {
    var t = _a.t;
    return (React.createElement("div", { "data-hook": "status" },
        React.createElement(Badge, { dataHook: "partial-badge", skin: statusToSkin(InvoiceStatus.PartiallyPaid) }, t("invoice-view:quote.preview_status." + InvoiceStatus.PartiallyPaid.toLowerCase())),
        React.createElement(Badge, { dataHook: "overdue-badge", skin: statusToSkin(InvoiceStatus.Overdue) }, t("invoice-view:quote.preview_status." + InvoiceStatus.Overdue.toLowerCase()))));
};
export default translate(['invoice-view', 'locale-data'])(Status);
//# sourceMappingURL=Status.js.map